import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output } from "@angular/core";
import { CommonModule } from "@angular/common";

// Material MDC Imports
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatCardModule } from "@angular/material/card";

/**
 * Toolbar info panel component that displays informational messages with slide animation.
 * Used for showing contextual information when specific search modes are activated.
 */
@Component({
  selector: "app-compound-toolbar-info-panel",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./toolbar-info-panel.component.html",
  styleUrls: ["./toolbar-info-panel.component.scss"],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule, MatCardModule],
})
export class ToolbarInfoPanelComponent {
  /** Event emitted when panel visibility changes */
  @Output() closePanelEmitter = new EventEmitter<boolean>();

  /** Panel title */
  title = "Local search active";

  /** Panel description */
  description = "Click on the map to select a point for location-based search";

  /** Panel icon */
  icon = "place";

  constructor(private cdr: ChangeDetectorRef) {}

  /**
   * Closes the panel manually when user clicks the close button.
   */
  closePanel(): void {
    this.closePanelEmitter.emit(true);
    this.cdr.detectChanges();
  }
}
